import React, { useState } from 'react'
import { Avatar } from 'antd'
import { StringUtils } from 'main/common/utils/StringUtils'

interface IAvatarCPProps {
    size: 'large' | 'small' | 'default' | number
    shape?: 'circle' | 'square'
    src?: string
    name?: string
    backgroundColor?: string
    border?: string
}

/**
 * Componente para renderizar imagem de perfil
 *
 * Caso tenha passado imagem e seja valida, mostra imagem
 * Caso contrario, se passou nome mostra as iniciais
 * Caso contrario, mostra imagem padrao
 *
 * @author Kiara Martins
 * @author renatofs
 */
export function AvatarCP(props: IAvatarCPProps): JSX.Element {

    const [isValidSrc, setIsValidSrc] = useState<boolean>(!!props.src)
    const [nameIntials, setNameInitials] = useState<string>(props.name ? StringUtils.getFirstAndLastInitials(props.name) : '')

    /** Evento o link da imagem seja invalido. */
    function onError() {
        setIsValidSrc(false)

        if (props.name)
            setNameInitials(StringUtils.getFirstAndLastInitials(props.name))

        return true
    }

    return (
        <>
            {
                isValidSrc &&
                <Avatar
                    src={props.src}
                    size={props.size}
                    shape={props.shape ?? 'circle'}
                    onError={onError}
                />
            }

            {
                !isValidSrc && props.name &&
                <Avatar
                    size={props.size}
                    style={{ backgroundColor: props.backgroundColor, border: props.border }}
                    shape={props.shape ?? 'circle'}
                >
                    {nameIntials}
                </Avatar>
            }

            {
                !isValidSrc && !props.name &&
                <Avatar
                    src={`${process.env.PUBLIC_URL}/default-avatar-1.png`}
                    size={props.size}
                    shape={props.shape ?? 'circle'}
                />
            }
        </>
    )
}
